import {useI18n} from 'i18n/I18nContext'
import {appLocaleToBcp47} from 'i18n/locales'
import React, {useEffect, useMemo, useState} from 'react'
import styled from 'styled-components'
import {attendeeApiClient} from 'attendee/apiClient'
import {useAuth} from 'attendee/Auth/Providers/AuthProvider'
import {FullPageLoader} from 'attendee/theme/FullPageLoader'
import Page from 'attendee/theme/Page'
import {
  AttendeeCertificate,
  CertificateVariables,
} from 'organization/Event/Certification/Certificate'
import CertificateItem from 'attendee/Certificates/CertificateItem'

export function Certificates() {
  const {certificates, loading} = useGetCertificates()
  const {user} = useAuth()
  const {locale, t} = useI18n()

  const variables: CertificateVariables = {
    Име: user?.first_name,
    Фамилия: user?.last_name,
    Имейл: user?.email,
    Дата: new Date().toLocaleDateString(appLocaleToBcp47(locale)),
    certLocation: t('orgCert.defaultCertLocation'),
  }

  if (loading) {
    return <FullPageLoader />
  }

  return (
    <Page>
      <section className="event__schedule-area dark_light_class pt-55 pb-150">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xxl-7 col-xl-7 col-lg-6">
              <h2 className="section__title mb-35">
                {t('attendee.certificatesTitleBefore')}{' '}
                <span className="text__highlight">
                  {t('attendee.certificatesTitleHighlight')}
                </span>
              </h2>
            </div>

            {certificates && certificates.length === 0 ? (
              <EmptyState>{t('attendee.certificatesEmpty')}</EmptyState>
            ) : (
              <Grid>
                {certificates?.map((certificate) => (
                  <CertificateItem
                    certificate={certificate}
                    variables={variables}
                  />
                ))}
              </Grid>
            )}
          </div>
        </div>
      </section>
    </Page>
  )
}

function useGetCertificates() {
  const apiClient = useMemo(() => attendeeApiClient(), [])
  const [certificates, setCertificates] = useState<
    AttendeeCertificate[] | null
  >(null)
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiClient.get(`api/certificates`)
        setCertificates(response)
      } catch (error) {
        console.error(error)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [apiClient])

  return {certificates, loading}
}

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 2rem;
`

const EmptyState = styled.div`
  text-align: center;
  padding: 8rem 0;
  font-size: 1.2rem;
  color: ${({theme}) => theme?.colors?.textSecondary || '#777'};
`
